import { useEffect, useRef, type ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

const AUTH_ENABLED = import.meta.env.VITE_STRONOM_AUTH_FOUNDATION === "true";

type GateDecision = "bypassed_flag_off" | "redirect_login" | "allow";

interface RequireAuthProps {
  children: ReactNode;
}

export function RequireAuth({ children }: RequireAuthProps) {
  const location = useLocation();
  const { session, loading } = useAuth();
  const lastLogged = useRef<GateDecision | null>(null);

  useEffect(() => {
    let decision: GateDecision | null = null;

    if (!AUTH_ENABLED) {
      decision = "bypassed_flag_off";
    } else if (!loading && !session) {
      decision = "redirect_login";
    } else if (!loading && session) {
      decision = "allow";
    }

    if (decision && lastLogged.current !== decision) {
      console.log(`[AUTH_FOUNDATION] require_auth gate=${decision}`);
      lastLogged.current = decision;
    }
  }, [loading, session]);

  if (!AUTH_ENABLED) {
    return <>{children}</>;
  }

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center space-y-3">
          <div className="h-8 w-8 rounded-full border-2 border-primary border-t-transparent animate-spin mx-auto" />
          <p className="text-sm text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  if (!session) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <>{children}</>;
}
